import React, { useState } from 'react';
import api from '../lib/api';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { ShoppingCart, Loader2 } from 'lucide-react';

/**
 * Redirects to Paystack hosted checkout (secret-key server-side flow).
 * On return, StudentHome detects the ?reference= query param and verifies.
 */
export default function PaystackCheckout({ programme, admissionWindow = 'JAN' }) {
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/enrolments/initiate', {
        programme_id: programme.programme_id,
        admission_window: admissionWindow,
        callback_url: `${window.location.origin}/student/home`,
      });
      // Redirect to Paystack hosted checkout — backend already used secret key to create this
      window.location.href = data.authorization_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to initiate payment');
      setLoading(false);
    }
  };

  return (
    <Button onClick={handlePay} disabled={loading} className="rounded-xl btn-navy w-full">
      {loading ? (
        <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Redirecting to checkout...</>
      ) : (
        <><ShoppingCart className="w-4 h-4 mr-2" /> Enrol — GHS {Number(programme.price || 0).toLocaleString()}</>
      )}
    </Button>
  );
}
